<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions()"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList(true, 0)"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="getModelEvalList">查询</el-button>
            <el-button type="primary" @click="addModelEval">创建</el-button>
            <el-button type="primary" @click="refresh">更新所有机型评估</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="modelName" label="机型"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="origin" label="评估渠道">
          <template>
            <span>通用渠道</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteEvaluation(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑机型评估' : '新建机型评估'"
      :visible.sync="isDlg"
      width="800px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editModelEvalForm"
            :model="editModelEvalForm"
            :rules="editorFormRules"
            label-position="left"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editModelEvalForm.value"
                :disabled="true"
                style="width:180px"
              ></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editModelEvalForm.categoryId"
                placeholder="请选择"
                @change="getModelEvalParam(false)"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editModelEvalForm.brandId"
                placeholder="请选择"
                @change="getModelList(false, 2)"
              >
                <el-option
                  v-for="item in editBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelId">
              <el-select
                clearable
                v-model="editModelEvalForm.modelId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in editModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评估模型配置"></el-form-item>

            <el-row>
              <el-col :span="24">
                <span>物品信息</span>&nbsp;&nbsp;
                <el-select
                  clearable
                  placeholder="请选择"
                  v-model="itemTempPlateId"
                >
                  <el-option
                    v-for="item in itemTempPlateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option> </el-select
                >&nbsp;&nbsp;
                <el-button type="primary" @click="changeItemPlate()"
                  >应用</el-button
                >&nbsp;&nbsp;
                <span style="color:	#A9A9A9">{{ msgTip }}</span>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <el-checkbox-group v-model="itemCheckList">
                  <el-checkbox
                    v-for="item in itemOptionsArray"
                    :label="item.id"
                    :key="item.id"
                    @change="showOrHiddenItemValue(item)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row style="border: 1px color black;" v-if="isItemRefresh">
              <el-col :span="24">
                <eval-model-value-option
                  v-for="(item, index) in itemValueList"
                  :key="index"
                  :index="index"
                  type="1"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></eval-model-value-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <span>成色信息</span>&nbsp;&nbsp;
                <el-select
                  clearable
                  placeholder="请选择"
                  v-model="conditionTempPlateId"
                >
                  <el-option
                    v-for="item in conditionTempPlateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option> </el-select
                >&nbsp;&nbsp;
                <el-button type="primary" @click="changeConditionPlate()"
                  >应用</el-button
                >&nbsp;&nbsp;
                <span style="color:	#A9A9A9">{{ msgTip }}</span>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <el-checkbox-group v-model="conditionCheckList">
                  <el-checkbox
                    v-for="item in conditionValueOptions"
                    :label="item.id"
                    :key="item.id"
                    @change="showOrHiddenConditionValue(item)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row style="border: 1px color black;" v-if="isConditionRefresh">
              <el-col :span="24">
                <eval-model-value-option
                  v-for="(item, index) in conditionValueList"
                  :key="index"
                  :index="index"
                  type="2"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></eval-model-value-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <span>功能信息</span>&nbsp;&nbsp;
                <el-select
                  clearable
                  placeholder="请选择"
                  v-model="functionTempPlateId"
                >
                  <el-option
                    v-for="item in functionTempPlateList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option> </el-select
                >&nbsp;&nbsp;
                <el-button type="primary" @click="changeFunctionPlate()"
                  >应用</el-button
                >&nbsp;&nbsp;
                <span style="color:	#A9A9A9">{{ msgTip }}</span>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <el-checkbox-group v-model="functionCheckList">
                  <el-checkbox
                    v-for="item in functionValueOptions"
                    :label="item.id"
                    :key="item.id"
                    @change="showOrHiddenFunctionValue(item)"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row style="border: 1px color black;" v-if="isFunctionRefresh">
              <el-col :span="24">
                <eval-model-value-option
                  v-for="(item, index) in functionValueList"
                  :key="index"
                  :index="index"
                  type="3"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></eval-model-value-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EvalModelValueOption from "../../components/evalModelValueOption.vue";
export default {
  components: { EvalModelValueOption },
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        categoryId: null,
        modelId: null,
        brandId: null,
      },
      msgTip: "选择合适的模板并应用，会预填充评估信息，填充后可修改",
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      itemOptionsArray: this.global.itemOptions,

      // 新建编辑对话框数据

      isDlg: false,
      editModelEvalForm: {
        id: null,
        value: null,
        name: null,
        categoryId: null,
        modelId: null,
        brandId: null,
        conditionParam: [],
        functionParam: [],
        modelParam: [],
      },

      editorFormRules: {
        modelId: [{ required: true, message: "请输入机型", trigger: "change" }],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      queryCategoryOptions: [],
      queryBrandOptions: [],
      queryModelList: [],

      editModelList: [],
      editBrandOptions: [],

      itemTemplateValueByBrand: {},

      //物品信息可变框
      itemCheckList: [],
      itemValueList: [],
      isItemRefresh: true,

      //成色信息可变框
      conditionCheckList: [],
      conditionValueList: [],
      isConditionRefresh: true,

      //功能信息可变框
      functionValueList: [],
      isFunctionRefresh: true,
      functionCheckList: [],

      //成色值选项
      conditionValueOptions: [],
      //功能值选项
      functionValueOptions: [],

      //模板ID和模板列表
      functionTempPlateId: null,
      itemTempPlateId: null,
      conditionTempPlateId: null,
      itemTempPlateList: [],
      conditionTempPlateList: [],
      functionTempPlateList: [],

      //根据分类获取不同的参数
      evalModelParam: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteEvaluation(id){
      let self = this
        self.$confirm('是否删除').then(() => {
          self.$api.deleteEvaluation({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getModelEvalList()
          }
      })
      })
    
    },
    //获取子组件的值
    getCildrenValue(index, type, evalValueObject) {
      if (type === 1) {
        this.itemValueList[index] = evalValueObject;
      } else if (type === 2) {
        this.conditionValueList[index] = evalValueObject;
      } else if (type === 3) {
        this.functionValueList[index] = evalValueObject;
      }
    },
    //根据分类ID，获取等级评估信息
    getModelEvalParam(isEdit) {
      let self = this;
      self.resetFrom();
      if (
        this.editModelEvalForm.categoryId == null ||
        this.editModelEvalForm.categoryId == ""
      ) {
        return;
      }
      this.$api
        .queryEvaluationParam({
          categoryId: this.editModelEvalForm.categoryId,
        })
        .then((res) => {
          self.evalModelParam = res.data || {};
          self.editBrandOptions = self.evalModelParam.brands;
          self.itemTempPlateList = self.evalModelParam.thingTemplates;
          self.conditionTempPlateList = self.evalModelParam.conditionTemplates;
          self.functionTempPlateList = self.evalModelParam.functionTemplates;
          self.conditionValueOptions = self.evalModelParam.conditionValues;
          self.functionValueOptions = self.evalModelParam.functionValues;

          //编辑时初始化成色以及功能的选项值
          if (isEdit) {
            if (
              self.editModelEvalForm.conditionParam === undefined ||
              self.editModelEvalForm.functionParam === undefined ||
              self.editModelEvalForm.conditionParam.length <= 0 ||
              self.editModelEvalForm.functionParam.length <= 0
            ) {
              return;
            }
            let conditionParamObject = JSON.parse(
              self.editModelEvalForm.conditionParam
            );
            let functionParamObject = JSON.parse(
              self.editModelEvalForm.functionParam
            );

            conditionParamObject.forEach((item) => {
              self.conditionCheckList.push(item.id);
              let conditionValueSelectedList = item.children;
              let conditionValueOptionsTemp = JSON.parse(
                JSON.stringify(self.conditionValueOptions)
              );
              let conditionValue = conditionValueOptionsTemp.find(
                (e) => e.id == item.id
              );
              conditionValueSelectedList.forEach((e) => {
                conditionValue.children.forEach((e1) => {
                  if (e.id === e1.id) {
                    e1.selected = true;
                  }
                });
              });
              self.showOrHiddenConditionValue(conditionValue);
            });

            functionParamObject.forEach((item) => {
              self.functionCheckList.push(item.id);
              let functionValueSelectedList = item.children;
              let functionValueOptionsTemp = JSON.parse(
                JSON.stringify(self.functionValueOptions)
              );
              let functionValue = functionValueOptionsTemp.find(
                (e) => e.id == item.id
              );
              functionValueSelectedList.forEach((e) => {
                functionValue.children.forEach((e1) => {
                  if (e.id === e1.id) {
                    e1.selected = true;
                  }
                });
              });
              self.showOrHiddenFunctionValue(functionValue);
            });
          }
        });
    },
    //改变成色模板
    changeConditionPlate() {
      let self = this;
      this.conditionCheckList = [];
      this.conditionValueList = [];
      if (
        this.conditionTempPlateId === "" ||
        this.conditionTempPlateId === null
      ) {
        return;
      }
      let conditionTemp = this.conditionTempPlateList.find(
        (item) => item.id == this.conditionTempPlateId
      );
      let conditionParam = JSON.parse(conditionTemp.extParam);
      conditionParam.forEach((item) => {
        this.conditionCheckList.push(item.id);
        let conditionValueSelectedList = item.children;
        let conditionValueOptionsTemp = JSON.parse(
          JSON.stringify(this.conditionValueOptions)
        );
        let conditionValue = conditionValueOptionsTemp.find(
          (e) => e.id == item.id
        );
        conditionValueSelectedList.forEach((e) => {
          conditionValue.children.forEach((e1) => {
            if (e.id === e1.id) {
              e1.selected = true;
            }
          });
        });
        self.showOrHiddenConditionValue(conditionValue);
      });
    },
    //应用功能模板
    changeFunctionPlate() {
      let self = this;
      this.functionCheckList = [];
      this.functionValueList = [];
      if (
        this.functionTempPlateId === "" ||
        this.functionTempPlateId === null
      ) {
        return;
      }
      let functionTemp = this.functionTempPlateList.find(
        (item) => item.id == this.functionTempPlateId
      );
      let functionParam = JSON.parse(functionTemp.extParam);
      functionParam.forEach((item) => {
        this.functionCheckList.push(item.id);
        let functionValueSelectedList = item.children;
        let functionValueOptionsTemp = JSON.parse(
          JSON.stringify(this.functionValueOptions)
        );
        let functionValue = functionValueOptionsTemp.find(
          (e) => e.id == item.id
        );
        functionValueSelectedList.forEach((e) => {
          functionValue.children.forEach((e1) => {
            if (e.id === e1.id) {
              e1.selected = true;
            }
          });
        });
        self.showOrHiddenFunctionValue(functionValue);
      });
    },
    //改变物品应用模版
    changeItemPlate() {
      this.itemCheckList = [];
      this.itemValueList = [];
      if (this.itemTempPlateId === "" || this.itemTempPlateId === null) {
        return;
      }
      if (
        this.editModelEvalForm.brandId === "" ||
        this.editModelEvalForm.brandId === null
      ) {
        this.$message({
          message: "请选择品牌",
          type: "error",
        });
        return;
      }
      let itemTemp = this.itemTempPlateList.find(
        (item) => item.id == this.itemTempPlateId
      );
      this.itemCheckList = itemTemp.templateKey.split(",");
      let self = this;

      this.itemCheckList.forEach((item) => {
        let itemValue = this.itemOptionsArray.find((e) => e.id == item);
        self.showOrHiddenItemValue(itemValue);
      });
    },

    //改变分类，品牌和等级集合发生变化
    changeOtherOptions() {
      let self = this;
      self.$set(self.queryParamForm, "brandId", null);
      self.$set(self.queryParamForm, "modelId", null);
      self.$set(self, "queryModelList", []);
      self.getBrandOptions();
    },
    //机型 isQuery:表示是否查询 type：0 表示查询  1：修改初始化  2：修改操作
    getModelList(isQuery, type) {
      let brandId = isQuery
        ? this.queryParamForm.brandId
        : this.editModelEvalForm.brandId;
      isQuery
        ? this.$set(this.queryParamForm, "modelId", null)
        : this.$set(this.editModelEvalForm, "modelId", null);
      this.itemCheckList = [];
      this.itemValueList = [];
      if (brandId === "") {
        this.$set(this, isQuery ? "queryModelList" : "editModelList", []);
        this.$set(this, "itemTemplateValueByBrand", {});
      } else {
        let self = this;
        if (isQuery) {
          self.$api
            .getClass({
              brandId: brandId,
              typeKey: "phoneModal",
              status: 1,
              page: 1,
              size: 100000,
            })
            .then((res) => {
              self.queryModelList = res.data.records || [];
            });
        } else {
          self.getItemTemplateValueByBrand(isQuery, type);
        }
      }
    },
    //显示或隐藏成色选项
    showOrHiddenConditionValue(item) {
      let isSelected = false;
      for (let index = 0; index < this.conditionCheckList.length; index++) {
        let e = this.conditionCheckList[index];
        if (item.id === e) {
          isSelected = true;
          break;
        }
      }
      if (isSelected) {
        let itemTemp = item
        this.conditionValueList.push(itemTemp);
      } else {
        if (this.conditionValueList.length > 0) {
          for (let index = 0; index < this.conditionValueList.length; index++) {
            let e = this.conditionValueList[index];
            if (item.id === e.id) {
              if(e.children!=null&&e.children.length>0){
                  e.children.forEach(e1=>{e1.selected=false});
              }
              this.conditionValueList.splice(index, 1);
              break;
            }
          }
        }
      }
      this.isConditionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isConditionRefresh = true;
      });
    },
    //显示或隐藏功能选项
    showOrHiddenFunctionValue(item) {
      let isSelected = false;
      for (let index = 0; index < this.functionCheckList.length; index++) {
        let e = this.functionCheckList[index];
        if (item.id === e) {
          isSelected = true;
          break;
        }
      }
      if (isSelected) {
        let itemTemp = item
        this.functionValueList.push(itemTemp);
      } else {
        if (this.functionValueList.length > 0) {
          for (let index = 0; index < this.functionValueList.length; index++) {
            let e = this.functionValueList[index];
            if (item.id === e.id) {
               if(e.children!=null&&e.children.length>0){
                  e.children.forEach(e1=>{e1.selected=false});
              }
              this.functionValueList.splice(index, 1);
              break;
            }
          }
        }
      }
      this.isFunctionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isFunctionRefresh = true;
      });
    },
    refresh () {
      this.$api.refresh().then(res=>{
           if(res.code === 200) {
            this.currentPage = 1;
             this.getModelEvalList()
          }
          })
    },
    //显示或隐藏物品选项
    showOrHiddenItemValue(item) {
      let isSelected = false;
      for (let index = 0; index < this.itemCheckList.length; index++) {
        let e = this.itemCheckList[index];
        if (item.id === e) {
          isSelected = true;
          break;
        }
      }
      if (isSelected) {
        let itemTemp = {
          id: null,
          name: null,
          children: [],
          selecte: false
        };
        itemTemp.id = item.id;
        itemTemp.name = item.name;
        if (item.id === "sku_memory") {
          itemTemp.children = this.itemTemplateValueByBrand.skuMemory;
        } else if (item.id === "sku_purchase_channel") {
          itemTemp.children = this.itemTemplateValueByBrand.skuPurchaseChannel;
        } else if (item.id === "sku_body_color") {
          itemTemp.children = this.itemTemplateValueByBrand.skuBodyColor;
        } else if (item.id === "sku_warranty_duration") {
          itemTemp.children = this.itemTemplateValueByBrand.skuWarrantyDuration;
        } else if (item.id === "sku_small_model") {
          itemTemp.children = this.itemTemplateValueByBrand.skuSmallModel;
        } else if (item.id === "sku_network") {
          itemTemp.children = this.itemTemplateValueByBrand.skuNetwork;
        }else if (item.id === "sku_cpu") {
          itemTemp.children = this.itemTemplateValueByBrand.skuCpu;
        }else if (item.id === "sku_graphics_card") {
          itemTemp.children = this.itemTemplateValueByBrand.skuGraphicsCard;
        }else if (item.id === "sku_solid_drive") {
          itemTemp.children = this.itemTemplateValueByBrand.skuSolidDrive;
        }else if (item.id === "sku_mechanical_drive") {
          itemTemp.children = this.itemTemplateValueByBrand.skuMechanicalDrive;
        }else if (item.id === "sku_charging_interface") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingInterface;
            }else if (item.id === "sku_charging_method") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingMethod;
            }else if (item.id === "sku_case_size") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseSize;
            }else if (item.id === "sku_case_material") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseMaterial;
            }else if (item.id === "sku_watch_strap") {
              itemTemp.children = this.itemTemplateValueByBrand.skuWatchStrap;
            }else if (item.id === "sku_strap_color") {
              itemTemp.children = this.itemTemplateValueByBrand.skuStrapColor;
            }else if (item.id === "sku_left_right_ear") {
              itemTemp.children = this.itemTemplateValueByBrand.skuLeftRightEar;
            }else if (item.id === "sku_external_keyboard") {
              itemTemp.children = this.itemTemplateValueByBrand.skuExternalKeyboard;
            }else if (item.id === "sku_accessories_situation") {
              itemTemp.children = this.itemTemplateValueByBrand.skuAccessoriesSituation;
            }
        this.itemValueList.push(itemTemp);
      } else {
        if (this.itemValueList.length > 0) {
          for (let index = 0; index < this.itemValueList.length; index++) {
            let e = this.itemValueList[index];
            if (item.id === e.id) {
              if(e.children!=null&&e.children.length>0){
                  e.children.forEach(e1=>{e1.selected=false});
              }
              this.itemValueList.splice(index, 1);
              break;
            }
          }
        }
      }
      this.isItemRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isItemRefresh = true;
      });
    },
    //根据品牌，获取物品模板值
    getItemTemplateValueByBrand(isQuery, type) {
      if (
        this.editModelEvalForm.brandId === null ||
        this.editModelEvalForm.brandId === ""
      ) {
        return;
      }
      let self = this;
      self.$api
        .getEvalTemplateValueByBrand({
          brandId: this.editModelEvalForm.brandId,
        })
        .then((res) => {
          self.itemTemplateValueByBrand = res.data || {};
          self.editModelList = self.itemTemplateValueByBrand.phoneModel;

          if (
            type === 2 ||
            isQuery === true ||
            self.editModelEvalForm.modelParam == undefined ||
            self.editModelEvalForm.modelParam.length <= 0
          ) {
            return;
          }
          let modelParamObject = JSON.parse(self.editModelEvalForm.modelParam);
          if (modelParamObject.skuMemory!=null&&modelParamObject.skuMemory.length > 0) {
            self.itemCheckList.push("sku_memory");
            self.itemTemplateValueByBrand.skuMemory.forEach((e) => {
              modelParamObject.skuMemory.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }
          if (modelParamObject.skuPurchaseChannel!=null&&modelParamObject.skuPurchaseChannel.length > 0) {
            self.itemCheckList.push("sku_purchase_channel");
            self.itemTemplateValueByBrand.skuPurchaseChannel.forEach((e) => {
              modelParamObject.skuPurchaseChannel.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }
          if (modelParamObject.skuBodyColor!=null&&modelParamObject.skuBodyColor.length > 0) {
            self.itemCheckList.push("sku_body_color");
            self.itemTemplateValueByBrand.skuBodyColor.forEach((e) => {
              modelParamObject.skuBodyColor.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }
          if (modelParamObject.skuWarrantyDuration!=null&&modelParamObject.skuWarrantyDuration.length > 0) {
            self.itemCheckList.push("sku_warranty_duration");
            self.itemTemplateValueByBrand.skuWarrantyDuration.forEach((e) => {
              modelParamObject.skuWarrantyDuration.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }
          if (modelParamObject.skuSmallModel!=null&&modelParamObject.skuSmallModel.length > 0) {
            self.itemCheckList.push("sku_small_model");
            self.itemTemplateValueByBrand.skuSmallModel.forEach((e) => {
              modelParamObject.skuSmallModel.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }
          if (modelParamObject.skuNetwork!=null&&modelParamObject.skuNetwork.length > 0) {
            self.itemCheckList.push("sku_network");
            self.itemTemplateValueByBrand.skuNetwork.forEach((e) => {
              modelParamObject.skuNetwork.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuCpu!=null&&modelParamObject.skuCpu.length > 0) {
            self.itemCheckList.push("sku_cpu");
            self.itemTemplateValueByBrand.skuCpu.forEach((e) => {
              modelParamObject.skuCpu.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuGraphicsCard!=null&&modelParamObject.skuGraphicsCard.length > 0) {
            self.itemCheckList.push("sku_graphics_card");
            self.itemTemplateValueByBrand.skuGraphicsCard.forEach((e) => {
              modelParamObject.skuGraphicsCard.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuSolidDrive!=null&&modelParamObject.skuSolidDrive.length > 0) {
            self.itemCheckList.push("sku_solid_drive");
            self.itemTemplateValueByBrand.skuSolidDrive.forEach((e) => {
              modelParamObject.skuSolidDrive.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuMechanicalDrive!=null&&modelParamObject.skuMechanicalDrive.length > 0) {
            self.itemCheckList.push("sku_mechanical_drive");
            self.itemTemplateValueByBrand.skuMechanicalDrive.forEach((e) => {
              modelParamObject.skuMechanicalDrive.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuChargingInterface!=null&&modelParamObject.skuChargingInterface.length > 0) {
            self.itemCheckList.push("sku_charging_interface");
            self.itemTemplateValueByBrand.skuChargingInterface.forEach((e) => {
              modelParamObject.skuChargingInterface.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuChargingMethod!=null&&modelParamObject.skuChargingMethod.length > 0) {
            self.itemCheckList.push("sku_charging_method");
            self.itemTemplateValueByBrand.skuChargingMethod.forEach((e) => {
              modelParamObject.skuChargingMethod.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuCaseSize!=null&&modelParamObject.skuCaseSize.length > 0) {
            self.itemCheckList.push("sku_case_size");
            self.itemTemplateValueByBrand.skuCaseSize.forEach((e) => {
              modelParamObject.skuCaseSize.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuCaseMaterial!=null&&modelParamObject.skuCaseMaterial.length > 0) {
            self.itemCheckList.push("sku_case_material");
            self.itemTemplateValueByBrand.skuCaseMaterial.forEach((e) => {
              modelParamObject.skuCaseMaterial.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuWatchStrap!=null&&modelParamObject.skuWatchStrap.length > 0) {
            self.itemCheckList.push("sku_watch_strap");
            self.itemTemplateValueByBrand.skuWatchStrap.forEach((e) => {
              modelParamObject.skuWatchStrap.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuStrapColor!=null&&modelParamObject.skuStrapColor.length > 0) {
            self.itemCheckList.push("sku_strap_color");
            self.itemTemplateValueByBrand.skuStrapColor.forEach((e) => {
              modelParamObject.skuStrapColor.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuLeftRightEar!=null&&modelParamObject.skuLeftRightEar.length > 0) {
            self.itemCheckList.push("sku_left_right_ear");
            self.itemTemplateValueByBrand.skuLeftRightEar.forEach((e) => {
              modelParamObject.skuLeftRightEar.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuExternalKeyboard!=null&&modelParamObject.skuExternalKeyboard.length > 0) {
            self.itemCheckList.push("sku_external_keyboard");
            self.itemTemplateValueByBrand.skuExternalKeyboard.forEach((e) => {
              modelParamObject.skuExternalKeyboard.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          if (modelParamObject.skuAccessoriesSituation!=null&&modelParamObject.skuAccessoriesSituation.length > 0) {
            self.itemCheckList.push("sku_accessories_situation");
            self.itemTemplateValueByBrand.skuAccessoriesSituation.forEach((e) => {
              modelParamObject.skuAccessoriesSituation.forEach((e1) => {
                if (e.id === e1.id) {
                  e.selected = true;
                }
              });
            });
          }

          self.itemCheckList.forEach((item) => {
            let itemValue = self.itemOptionsArray.find((e) => e.id == item);
            self.showOrHiddenItemValue(itemValue);
          });
        });
    },

    getBrandOptions() {
      let categoryId = this.queryParamForm.categoryId;
      if (categoryId === "") {
        this.$set(this, "queryBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryBrandOptions = res.data.records || [];
          });
      }
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getModelEvalList();
    },

    // 获取表格数据
    getModelEvalList() {
      let self = this;
      self.$api
        .evaluationListSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryParamForm.categoryId || null,
          brandId: self.queryParamForm.brandId || null,
          modelId: self.queryParamForm.modelId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addModelEval() {
      this.dlgType = "new";
      this.editModelEvalForm = {
        id: null,
        value: null,
        name: null,
        categoryId: null,
        modelId: null,
        brandId: null,
        conditionParam: [],
        functionParam: [],
        modelParam: [],
      };
     
      this.resetFrom();
      this.$nextTick(()=>{
          this.$refs['editModelEvalForm'].clearValidate()
      })
      this.isDlg = true;
    },
    //重置表单
    resetFrom() {
      this.editModelList = [];
      this.editBrandOptions = [];
      this.itemTempPlateList = [];
      this.conditionTempPlateList = [];
      this.functionTempPlateList = [];
      this.conditionValueOptions = [];
      this.functionValueOptions = [];
      this.itemCheckList = [];
      this.functionCheckList = [];
      this.conditionCheckList = [];
      this.itemValueList = [];
      this.conditionValueList = [];
      this.functionValueList = [];
      this.itemTempPlateId = null;
      this.conditionTempPlateId = null;
      this.functionTempPlateId = null;
      this.editModelEvalForm.modelId = null;
      this.editModelEvalForm.brandId = null;
      this.itemTemplateValueByBrand = {};
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      this.editModelEvalForm = {
        id: null,
        value: null,
        name: null,
        categoryId: null,
        modelId: null,
        brandId: null,
        conditionParam: [],
        functionParam: [],
        modelParam: [],
      };

      self.editModelEvalForm = JSON.parse(JSON.stringify(row));
      self.getModelEvalParam(true);
      this.editModelEvalForm.brandId = row.brandId;
      self.getModelList(false, 1);
      this.editModelEvalForm.modelId = row.modelId;
      self.isDlg = true;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editModelEvalForm"].validate((valid) => {
        if (valid) {
          let params = this.editModelEvalForm;
          this.itemValueList.forEach((item) => {
            if (item.id === "sku_memory") {
              this.itemTemplateValueByBrand.skuMemory = item.children;
            } else if (item.id === "sku_purchase_channel") {
              this.itemTemplateValueByBrand.skuPurchaseChannel = item.children;
            } else if (item.id === "sku_body_color") {
              this.itemTemplateValueByBrand.skuBodyColor = item.children;
            } else if (item.id === "sku_warranty_duration") {
              this.itemTemplateValueByBrand.skuWarrantyDuration = item.children;
            } else if (item.id === "sku_small_model") {
              this.itemTemplateValueByBrand.skuSmallModel = item.children;
            } else if (item.id === "sku_network") {
              this.itemTemplateValueByBrand.skuNetwork = item.children;
            }else if (item.id === "sku_cpu") {
              this.itemTemplateValueByBrand.skuCpu  = item.children;
            }else if (item.id === "sku_graphics_card") {
               this.itemTemplateValueByBrand.skuGraphicsCard  = item.children;
            }else if (item.id === "sku_solid_drive") {
               this.itemTemplateValueByBrand.skuSolidDrive  = item.children;
            }else if (item.id === "sku_mechanical_drive") {
               this.itemTemplateValueByBrand.skuMechanicalDrive  = item.children;
            }else if (item.id === "sku_charging_interface") {
               this.itemTemplateValueByBrand.skuChargingInterface = item.children;
            }else if (item.id === "sku_charging_method") {
              this.itemTemplateValueByBrand.skuChargingMethod = item.children;
            }else if (item.id === "sku_case_size") {
              this.itemTemplateValueByBrand.skuCaseSize = item.children;
            }else if (item.id === "sku_case_material") {
              this.itemTemplateValueByBrand.skuCaseMaterial = item.children;
            }else if (item.id === "sku_watch_strap") {
              this.itemTemplateValueByBrand.skuWatchStrap = item.children;
            }else if (item.id === "sku_strap_color") {
              this.itemTemplateValueByBrand.skuStrapColor = item.children;
            }else if (item.id === "sku_left_right_ear") {
              this.itemTemplateValueByBrand.skuLeftRightEar = item.children;
            }else if (item.id === "sku_external_keyboard") {
              this.itemTemplateValueByBrand.skuExternalKeyboard= item.children;
            }else if (item.id === "sku_accessories_situation") {
              this.itemTemplateValueByBrand.skuAccessoriesSituation= item.children;
            }
          });
          params.modelParam = JSON.stringify(this.itemTemplateValueByBrand);
          params.conditionParam = JSON.stringify(this.conditionValueList);
          params.functionParam = JSON.stringify(this.functionValueList);
          self.$api.updateEvaluation(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getModelEvalList();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      self.$api.updateEvaluation(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          self.getModelEvalList();
        }
      });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .evaluationSwap({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getModelEvalList();
          }
        });
    },
    getCategroyOptions() {
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getModelEvalList();
    self.getCategroyOptions();
  },
};
</script>
<style lang="less" scoped></style>
